
<mat-expansion-panel [expanded]="isExpanded()">
  <mat-expansion-panel-header>Filtrer les réponses / demandes</mat-expansion-panel-header>
  <mat-card>
    <mat-card-content>
      <div style="padding-bottom: 10px;">
        <app-filter-response-enabled *ngIf="fieldsEnabled && fieldsEnabled.length > 0"
                                   [fields]="fieldsEnabled"
                                   (onFilterRaz)="onFilterRaz($event)"></app-filter-response-enabled>
        <mat-divider></mat-divider>
      </div>
      <div>
        <mat-form-field *ngIf="fields">
          <mat-select placeholder="Réponses à filtrer"
                      (selectionChange)="onSelectField($event)" data-cy="select-filter-fields-response-selection-answers-filtering">
            <mat-option *ngFor="let field of fields"
                        [value]="field" [attr.data-cy]="'option-filter-fields-response-'+field.id">{{field.label}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="selectedField">
          <app-filter-response-type [field]="selectedField"
                                    [form]="form"
                                    (valueChanged)="onValueChanged($event)"></app-filter-response-type>
        </div>
        <div style="padding-top: 10px;">
          <button color="accent" class="mat-button mat-small" mat-raised-button
                  [disabled]="isDisabled()"
                  (click)="onAddFilter()" matTooltip="Filtrer">Ajouter ce filtre</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</mat-expansion-panel>
